import Decimal from 'decimal.js';

export function getNumericEcrKeys(columns: any[]): string[] {
  return columns.filter((col) => col.numeric).map((col) => col.name);
}

export function buildEcrTotalRow(
  rows: any[],
  numericKeys: string[],
  label: string
): any {
  const totalRow: any = {
    typInsD: label,
    isTotalRow: true, // marker so consumers of the array can skip this synthetic row
    cssStyle: {
      'background-color': '#fafafa',
      'font-weight': '500',
    },
  };

  for (const key of numericKeys) {
    // Track real values separately: a column blank in every row must show a dash
    // (like the data rows), not a misleading 0.
    let hasAnyValue = false;

    const sum = rows.reduce((acc, row) => {
      const raw = row?.[key];
      const isRealValue =
        raw !== null && raw !== undefined && raw !== '' && !isNaN(Number(raw));

      if (isRealValue) {
        hasAnyValue = true;
        return acc.plus(new Decimal(Number(raw)));
      }
      return acc;
    }, new Decimal(0));

    totalRow[key] = hasAnyValue
      ? sum.toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber()
      : undefined;
  }

  return totalRow;
}
